module.exports = __webpack_public_path__ + "static/media/swiperight.3d4364c0.png";